var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"breadcrumb"}},[_c('v-breadcrumbs',{staticClass:"pb-2",attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }